
/* styles */
require("!!../../node_modules/extract-text-webpack-plugin/dist/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?sourceMap!../../node_modules/vue-loader/lib/style-compiler/index?{\"id\":\"data-v-1883b718\",\"scoped\":true,\"hasInlineConfig\":true}!sass-loader?sourceMap!../../node_modules/vue-loader/lib/selector?type=styles&index=0!./audio-player.vue")

var Component = require("!../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../node_modules/vue-loader/lib/selector?type=script&index=0!./audio-player.vue"),
  /* template */
  require("!!../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-1883b718\"}!../../node_modules/vue-loader/lib/selector?type=template&index=0!./audio-player.vue"),
  /* scopeId */
  "data-v-1883b718",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./client/components/audio-player.vue
// module id = 29
// module chunks = 42